module.exports = __webpack_public_path__ + "assets/img/icon_vs.7657ca39.png";